import { baseThemeValues } from 'constants/common';

export const componentRowActionsTheme = {
  activeButton: 'palette.primary.20',
  pagesTitle: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '11px',
    fontWeight: 600,
    text: 'palette.neutral.70',
  },
};
